import { Link as LLink } from '@tv2/lib-offspring/components/link/Link';
import type { ICID } from '@tv2/lib-tracking/icid';
import { PropsWithChildren } from 'react';
import { DestinationFragment } from '../hooks/__generated__/destination';
import { ActionType } from '../types/actions';

export function Link({
  destination,
  action,
  onAction,
  children,
}: {
  destination: DestinationFragment | undefined | null;
  action?: ActionType | null;
  onAction?: (action: ActionType) => void;
} & PropsWithChildren): React.ReactNode {
  const opensEntitlement = action?.clientAction?.__typename === 'OpenEntitlementClientAction';

  if (destination === null || destination === undefined) {
    return children;
  }
  if (process.env.NODE_ENV === 'development' && !destination.icid) {
    // biome-ignore lint/suspicious/noConsole: Intentional warning for missing tracking data
    console.warn(
      `[Link] Destination is missing icid — tracking will not work. path="${destination.path}" type="${destination.type}"`
    );
  }
  return (
    <LLink
      href={destination.path}
      onClick={event => {
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          !opensEntitlement ||
          !onAction
        )
          return;
        event.preventDefault();
        onAction(action);
      }}
      tracking={
        destination.icid
          ? {
              icid: destination.icid as ICID,
              status: 'ready',
            }
          : undefined
      }
    >
      {children}
    </LLink>
  );
}
